import React, { Component } from 'react'

import { Textfield } from 'react-mdl'
import Button from './Button'

class ConfirmDelete extends Component {
  state = { value: '' }

  handleDelete = () => {
    this.props.callback('Delete')
  }

  handleChange = ({ target }) => this.setState({ value: target.value })

  render() {
    const { value } = this.state
    return (
      <div>
        <p>Are you sure you want to delete this?</p>
        <Textfield
          label="Enter delete to confirm."
          value={value}
          onChange={this.handleChange}
        />
        <Button
          disabled={value.toLowerCase() !== 'delete'}
          raised
          primary
          onClick={this.handleDelete}>
          Delete
        </Button>
      </div>
    )
  }
}

export default ConfirmDelete



// WEBPACK FOOTER //
// ./src/components/ConfirmDelete.js